import { useParams as useReactRouterParams } from 'react-router-dom'

export { useParams }

const useParams = (): Readonly<Record<string, string | undefined>> => {
  const params = useReactRouterParams()

  return Object.freeze(params)
}
